import {
  GetOneSmartInterviewOutput,
  SmartInterviewsBuilder,
  GetOneSmartInterviewInput,
} from '../smart-interviews.types';

export const getOneSmartInterview = (builder: SmartInterviewsBuilder) =>
  builder.query<GetOneSmartInterviewOutput, GetOneSmartInterviewInput>({
    query: ({ smartInterviewId }) => ({
      url: `/smart-interview-questions/${smartInterviewId}/audio`,
      method: 'GET',
    }),
    providesTags: (result, error, { smartInterviewId }) => [
      { type: 'SmartInterviews', id: smartInterviewId },
    ],
  });
